class SectionProductMain extends HTMLElement {
  constructor() {
    super();

    this.elements = {
      form: this.querySelector(".js-section-product-main-form"),
      shareButton: this.querySelector("[id^='ProductMain-Button-Share']"),
      bottomBar: this.querySelector("[id^='ProductMain-BottomBar']"),
    };

    if (this.elements.shareButton) {
      this.setupShareButton();
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (this.elements.bottomBar) {
            this.elements.bottomBar.classList.remove("is-visible");
          }
        } else {
          if (this.elements.bottomBar) {
            this.elements.bottomBar.classList.add("is-visible");
          }
        }
      });
    });

    observer.observe(this.elements.form);
  }

  setupShareButton() {
    this.elements.shareButton.addEventListener("click", (event) => {
      event.preventDefault();
      navigator.share({
        title: document.title,
        url: window.location.href,
        description: document.querySelector("meta[name='description']").content,
      });
    });
  }
}

if (window.customElements.get("section-production-main") === undefined) {
  window.customElements.define("section-product-main", SectionProductMain);
}
